import * as angular from "angular";
import { NationBuilderService } from "../services/nation-builder.service";
import { httpHandler } from "../utils/http-handler";

export class NationBuilderDataProvider {
    public nbStatuses: any = null;

    private $q: any;
    private resource: NationBuilderService;

    constructor($q: any, NationBuilderService: NationBuilderService) {
        this.$q = $q;
        this.resource = NationBuilderService;
    }

    clearAll(): void {
        this.nbStatuses = null;
    }

    getNationBuilderStatuses(): Promise<any> {
        const deferred = this.$q.defer();
        if (this.nbStatuses !== null) {
            deferred.resolve(this.nbStatuses);
        } else {
            this.resource.contactStatuses().then(
                (response: object) =>
                    httpHandler.handleResponse(
                        deferred,
                        response,
                        (json: object) => {
                            this.nbStatuses = json["data"];
                            return this.nbStatuses;
                        }
                    ),
                (error: object) => deferred.reject(error)
            );
        }
        return deferred.promise;
    }

    getNations(): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.nations().then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    deleteNation(nation: any): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.delete(nation).then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    updateNation(nation: any): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.update(nation).then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    cancelImport(importItem: any): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.cancelImport(importItem).then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    deleteNBImport(list: any): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.deleteNBImport(list).then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getLists(nationBuilderId: string | number): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.lists({ item: nationBuilderId }).then(
            (response: object) =>
                httpHandler.handleResponse(
                    deferred,
                    response,
                    (json: object) => {
                        return json["data"].results;
                    }
                ),
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getImports(nationBuilderSlug: string): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.imports({ item: nationBuilderSlug }).then(
            (response: object) =>
                httpHandler.handleResponse(deferred, response),
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    import(nationBuilderSlug: string, data: any): Promise<string> {
        const deferred = this.$q.defer();
        this.resource.import(nationBuilderSlug, data).then(
            (response: object) => {
                httpHandler.handleResponse(
                    deferred,
                    response,
                    (json: object) => {
                        const importId = json["id"];
                        return importId;
                    }
                );
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("NationBuilderDataProvider", NationBuilderDataProvider);
